import * as React from 'react'
import BaseIcon from '../../BaseIcon'

export default class NotInListIcon extends BaseIcon {
  getChildren = () => [
    <path fill={ this.getColor() }
          d='M11.46,6.9V6.39l-.89,1.22a1.5,1.5,0,0,0,1.23.85v.08A1.78,1.78,0,0,0,10.75,9a1.56,1.56,0,0,0-.34,1.07v1.83a1.09,1.09,0,0,1-.36.91,1.73,1.73,0,0,1-1.05.3V14a2.86,2.86,0,0,0,1.82-.54A1.81,1.81,0,0,0,11.46,12V10.13a1,1,0,0,1,.39-.92A2,2,0,0,1,13,8.94V8.07a2.1,2.1,0,0,1-1.18-.29A1,1,0,0,1,11.46,6.9Z'/>,
    <path fill={ this.getColor() }
          d='M10,3.13A3.46,3.46,0,0,0,9,3v.86a1.77,1.77,0,0,1,.42.06Z'
    />,
    <polygon fill={ this.getColor() } points="3.94 15 3 14.43 12.06 2 13 2.57 3.94 15"/>,
    <path  fill={ this.getColor() } d="M4.54,10.13v.48l.9-1.23A1.17,1.17,0,0,0,5.25,9a1.78,1.78,0,0,0-1-.49V8.46A1.46,1.46,0,0,0,5.59,6.9V5.08c0-.79.47-1.2,1.41-1.22V3a2.76,2.76,0,0,0-1.8.54A1.79,1.79,0,0,0,4.54,5V6.9a1,1,0,0,1-.36.88A2.1,2.1,0,0,1,3,8.07v.87a2,2,0,0,1,1.15.27A1,1,0,0,1,4.54,10.13Z"/>,
    <path  fill={ this.getColor() } d="M6,13.87A3.85,3.85,0,0,0,7,14v-.86a2.49,2.49,0,0,1-.42-.06Z"/>
        ]
  getViewBox = () => '0 0 16 16'
}
